// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Form renders the component 1`] = `
.c2 {
  font-weight: 500;
  padding: 0;
  margin: 0;
  font-size: 2.125rem;
  line-height: 120%;
}

.c3 {
  font-weight: 500;
  padding: 0;
  margin: 0;
  color: #737482;
  font-size: 0.875rem;
  line-height: 140%;
}

.c12 {
  font-weight: 500;
  padding: 0;
  margin: 0;
  color: #737482;
  font-size: 0.875rem;
  line-height: 140%;
  font-size: 0.75rem;
}

.c0 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.c4 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.c5 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 10px;
}

.c6 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.c8 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.c10 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.c16 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}

.c18 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: flex-start;
  -webkit-box-align: flex-start;
  -ms-flex-align: flex-start;
  align-items: flex-start;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.c23 {
  font-family: 'Montserrat',sans-serif;
  margin: 0;
  overflow: visible;
  -webkit-appearance: button;
}

.c23::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

.c24 {
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 0.125rem;
  border: 1px solid transparent;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  font-weight: 500;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  line-height: 1;
  outline: none;
  text-transform: uppercase;
  white-space: nowrap;
  font-size: 0.875rem;
  height: 2rem;
  padding: 0 0.625rem;
}

.c24:disabled:disabled {
  background-color: rgba(37,38,46,0.15);
  border-color: transparent;
  color: rgba(37,38,46,0.4);
  cursor: not-allowed;
}

.c14 {
  display: inline;
  margin-left: 3px;
  margin-top: 0px;
}

.c7 {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  max-width: 100%;
}

.c9 {
  background: #fff;
  border: 1px solid #c5cad3;
  box-sizing: border-box;
  min-height: 50px;
  position: relative;
  width: 100%;
  cursor: text;
  height: 32px;
}

.c9 ~ * {
  cursor: default;
  margin-top: 5px;
  width: 100%;
}

.c9:hover {
  border-color: #61b0ff;
}

.c9:active {
  border-color: #1c6ee6;
  box-shadow: inset 0 0 0 2px rgba(28,110,230,0.4);
}

.c19 {
  color: #737482;
  margin: 16px 0 6px 15px;
  margin: 0;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
}

.c11 {
  max-width: 100%;
  padding-top: 6px;
  padding-left: 15px;
  padding-left: 10px;
}

.c13 {
  display: block;
  padding-right: 10px;
  text-align: left;
  width: 100%;
  cursor: inherit;
}

.c13 * {
  cursor: inherit;
}

.c17 {
  font-family: 'Montserrat',sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  overflow: visible;
  background-color: inherit;
  border: transparent;
  display: block;
  line-height: 140%;
  padding-right: 0.625rem;
  padding-left: 0.0625rem;
  width: 100%;
  padding-bottom: 0.375rem;
  font-weight: 800;
  -webkit-letter-spacing: 0.125rem;
  -moz-letter-spacing: 0.125rem;
  -ms-letter-spacing: 0.125rem;
  letter-spacing: 0.125rem;
}

.c17::-moz-focus-inner {
  border: 0;
  padding: 0;
  margin: 0;
}

.c17:active,
.c17:focus {
  outline: none;
}

.c20 {
  margin-right: 0.125rem;
  cursor: pointer;
  width: 1.125rem;
  height: 1.875rem;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 0.125rem;
  border: 1px solid transparent;
}

.c20,
.c20:hover {
  color: #1c6ee6;
}

.c20:focus {
  box-shadow: inset 0 0 0 2px rgba(28,110,230,0.4);
  border: 1px solid #1c6ee6;
  outline: none;
}

.c15 {
  font-family: 'Montserrat',sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  overflow: visible;
  background-color: inherit;
  border: transparent;
  display: block;
  line-height: 140%;
  padding: 0 10px 6px 1px;
  width: 100%;
}

.c15::-moz-focus-inner {
  border: 0;
  padding: 0;
  margin: 0;
}

.c15:active,
.c15:focus {
  outline: none;
}

.c22 {
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  row-gap: 5px;
  -webkit-align-items: start;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: start;
}

.c1 {
  width: 560px;
  background-color: #fff;
  padding: 50px 40px;
}

.c21 {
  font-size: 12px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  color: #737482;
  line-height: 140%;
  margin-bottom: 2px;
}

@media screen and (max-width:390px) {
  .c22 {
    -webkit-flex-direction: column-reverse;
    -ms-flex-direction: column-reverse;
    flex-direction: column-reverse;
  }

  .c22 .btn__element--login-btn {
    margin-bottom: 15px;
  }
}

<div>
  <div
    class="c0 c1"
  >
    <h1
      class="c2"
      style="text-align: center; margin: 0px; padding: 0px;"
    >
      Welcome to 
      Portal Name
    </h1>
    <p
      class="c3"
      font-weight="500"
      style="text-align: center; margin-bottom: 40px;"
    >
      Collaborate with 
      Location Name
       in managing repairs efficiently.
      <br />
      Get started by configuring your profile:
    </p>
    <div
      class="c4"
      style="width: 360px;"
    >
      <div
        class="c5"
      >
        <div
          class="c6 c7"
        >
          <div
            class="c8 c9"
            cursor="text"
          >
            <div
              class="c10 c11"
            >
              <label
                class="c12 c13"
                color="alaskanHusky"
                for="input-field-target-1"
                id="input-field-target-1-label"
              >
                <span>
                  First Name
                  <div
                    aria-controls=""
                    aria-expanded="false"
                    aria-haspopup="dialog"
                    aria-label="Required"
                    class="c14"
                  >
                    <svg
                      color="#009eff"
                      fill="none"
                      focusable="false"
                      height="12"
                      viewBox="0 0 16 16"
                      width="12"
                    >
                      <path
                        d="M8 2.5a1 1 0 011 1v3.613l3.184-1.062a1 1 0 01.633 1.898L9.633 9.01 11.8 11.9a1 1 0 01-1.6 1.2L8 10.167 5.8 13.1a1 1 0 11-1.6-1.2l2.168-2.89-3.184-1.061a1 1 0 01.632-1.898L7 7.113V3.5a1 1 0 011-1z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                </span>
              </label>
              <input
                aria-labelledby="input-field-target-1-label"
                class="c15"
                id="input-field-target-1"
                name="first_name"
                required=""
                value=""
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="c5"
      >
        <div
          class="c6 c7"
        >
          <div
            class="c8 c9"
            cursor="text"
          >
            <div
              class="c10 c11"
            >
              <label
                class="c12 c13"
                color="alaskanHusky"
                for="input-field-target-3"
                id="input-field-target-3-label"
              >
                <span>
                  Last Name
                  <div
                    aria-controls=""
                    aria-expanded="false"
                    aria-haspopup="dialog"
                    aria-label="Required"
                    class="c14"
                  >
                    <svg
                      color="#009eff"
                      fill="none"
                      focusable="false"
                      height="12"
                      viewBox="0 0 16 16"
                      width="12"
                    >
                      <path
                        d="M8 2.5a1 1 0 011 1v3.613l3.184-1.062a1 1 0 01.633 1.898L9.633 9.01 11.8 11.9a1 1 0 01-1.6 1.2L8 10.167 5.8 13.1a1 1 0 11-1.6-1.2l2.168-2.89-3.184-1.061a1 1 0 01.632-1.898L7 7.113V3.5a1 1 0 011-1z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                </span>
              </label>
              <input
                aria-labelledby="input-field-target-3-label"
                class="c15"
                id="input-field-target-3"
                name="last_name"
                required=""
                value=""
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="c5"
      >
        <div
          class="c6 c7"
        >
          <div
            class="c8 c9"
            cursor="text"
          >
            <div
              class="c10 c11"
            >
              <label
                class="c12 c13"
                color="alaskanHusky"
                for="input-field-target-5"
                id="input-field-target-5-label"
              >
                <span>
                  Email
                  <div
                    aria-controls=""
                    aria-expanded="false"
                    aria-haspopup="dialog"
                    aria-label="Required"
                    class="c14"
                  >
                    <svg
                      color="#009eff"
                      fill="none"
                      focusable="false"
                      height="12"
                      viewBox="0 0 16 16"
                      width="12"
                    >
                      <path
                        d="M8 2.5a1 1 0 011 1v3.613l3.184-1.062a1 1 0 01.633 1.898L9.633 9.01 11.8 11.9a1 1 0 01-1.6 1.2L8 10.167 5.8 13.1a1 1 0 11-1.6-1.2l2.168-2.89-3.184-1.061a1 1 0 01.632-1.898L7 7.113V3.5a1 1 0 011-1z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                </span>
              </label>
              <input
                aria-labelledby="input-field-target-5-label"
                class="c15"
                id="input-field-target-5"
                name="email"
                required=""
                value="email@email.com"
              />
            </div>
          </div>
          
        </div>
      </div>
      <div
        class="c6 c7"
      >
        <div
          class="c8 c9"
          cursor="text"
        >
          <div
            class="c10 c11"
          >
            <label
              class="c12 c13"
              color="alaskanHusky"
              for="input-field-target-7"
              id="input-field-target-7-label"
            >
              <span>
                Password
                <div
                  aria-controls=""
                  aria-expanded="false"
                  aria-haspopup="dialog"
                  aria-label="Required"
                  class="c14"
                >
                  <svg
                    color="#009eff"
                    fill="none"
                    focusable="false"
                    height="12"
                    viewBox="0 0 16 16"
                    width="12"
                  >
                    <path
                      d="M8 2.5a1 1 0 011 1v3.613l3.184-1.062a1 1 0 01.633 1.898L9.633 9.01 11.8 11.9a1 1 0 01-1.6 1.2L8 10.167 5.8 13.1a1 1 0 11-1.6-1.2l2.168-2.89-3.184-1.061a1 1 0 01.632-1.898L7 7.113V3.5a1 1 0 011-1z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              </span>
            </label>
            <div
              class="c16"
            >
              <input
                aria-labelledby="input-field-target-7-label"
                autocomplete="off"
                class="c17"
                data-testid="password-input"
                id="input-field-target-7"
                name="password"
                required=""
                role="password"
                type="password"
                value=""
              />
            </div>
          </div>
          <div
            class="c18 c19"
          >
            <div
              aria-controls=""
              aria-expanded="false"
              aria-haspopup="dialog"
              class="c8 c20"
              tabindex="0"
            >
              <svg
                aria-expanded="false"
                color="currentColor"
                data-testid="toggle-password-visible"
                focusable="false"
                height="16"
                role="button"
                viewBox="0 0 16 16"
                width="16"
              >
                <path
                  d="M8 4C5.7 4 3.399 5.658 2.122 8 3.399 10.342 5.7 12 8 12c2.3 0 4.601-1.658 5.878-4C12.601 5.658 10.3 4 8 4zm0-2c3.288 0 6.378 2.36 7.903 5.57a1 1 0 010 .86C14.378 11.64 11.288 14 8 14 4.712 14 1.622 11.64.097 8.43a1 1 0 010-.86C1.622 4.36 4.712 2 8 2zm1 6a1 1 0 112 0 3 3 0 11-3-3 1 1 0 110 2 1 1 0 101 1z"
                  fill="currentColor"
                  fill-rule="nonzero"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div
        style="margin: 5px 0px 20px;"
      >
        <div
          class="c21"
        >
          <svg
            color="#C5CAD3"
            fill="none"
            focusable="false"
            height="12"
            style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
            viewBox="0 0 16 16"
            width="12"
          >
            <path
              d="M10.7 6.7L9.4 8l1.3 1.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3L8 9.4l-1.3 1.3c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L6.6 8 5.3 6.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L8 6.6l1.3-1.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4z"
              fill="currentColor"
            />
            <path
              clip-rule="evenodd"
              d="M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM8 2C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z"
              fill="currentColor"
              fill-rule="evenodd"
            />
          </svg>
          Contain at least 8 characters
        </div>
        <div
          class="c21"
        >
          <svg
            color="#C5CAD3"
            fill="none"
            focusable="false"
            height="12"
            style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
            viewBox="0 0 16 16"
            width="12"
          >
            <path
              d="M10.7 6.7L9.4 8l1.3 1.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3L8 9.4l-1.3 1.3c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L6.6 8 5.3 6.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L8 6.6l1.3-1.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4z"
              fill="currentColor"
            />
            <path
              clip-rule="evenodd"
              d="M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM8 2C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z"
              fill="currentColor"
              fill-rule="evenodd"
            />
          </svg>
          Contain at least three of the following: uppercase letters, lowercase letters, digits, and special characters
        </div>
        <div
          class="c21"
        >
          <svg
            color="#C5CAD3"
            fill="none"
            focusable="false"
            height="12"
            style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
            viewBox="0 0 16 16"
            width="12"
          >
            <path
              d="M10.7 6.7L9.4 8l1.3 1.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3L8 9.4l-1.3 1.3c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L6.6 8 5.3 6.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L8 6.6l1.3-1.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4z"
              fill="currentColor"
            />
            <path
              clip-rule="evenodd"
              d="M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM8 2C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z"
              fill="currentColor"
              fill-rule="evenodd"
            />
          </svg>
          Not contain more than two identical characters in a row
        </div>
      </div>
      <div
        class="c8 c22"
      >
        <div
          class="btn__element--login-btn"
        >
          <button
            class="c23 c24"
            disabled=""
            type="button"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
`;

exports[`Form when all fields are valid renders the component 1`] = `
.c2 {
  font-weight: 500;
  padding: 0;
  margin: 0;
  font-size: 2.125rem;
  line-height: 120%;
}

.c3 {
  font-weight: 500;
  padding: 0;
  margin: 0;
  color: #737482;
  font-size: 0.875rem;
  line-height: 140%;
}

.c12 {
  font-weight: 500;
  padding: 0;
  margin: 0;
  color: #737482;
  font-size: 0.875rem;
  line-height: 140%;
  font-size: 0.75rem;
}

.c0 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.c4 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.c5 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 10px;
}

.c6 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.c8 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.c10 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.c17 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}

.c19 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: flex-start;
  -webkit-box-align: flex-start;
  -ms-flex-align: flex-start;
  align-items: flex-start;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.c24 {
  font-family: 'Montserrat',sans-serif;
  margin: 0;
  overflow: visible;
  -webkit-appearance: button;
}

.c24::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

.c25 {
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 0.125rem;
  border: 1px solid transparent;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  font-weight: 500;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  line-height: 1;
  outline: none;
  text-transform: uppercase;
  white-space: nowrap;
  font-size: 0.875rem;
  height: 2rem;
  padding: 0 0.625rem;
}

.c25:disabled:disabled {
  background-color: rgba(37,38,46,0.15);
  border-color: transparent;
  color: rgba(37,38,46,0.4);
  cursor: not-allowed;
}

.c14 {
  display: inline;
  margin-left: 3px;
  margin-top: 0px;
}

.c7 {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  max-width: 100%;
}

.c9 {
  background: #fff;
  border: 1px solid #c5cad3;
  box-sizing: border-box;
  min-height: 50px;
  position: relative;
  width: 100%;
  cursor: text;
  height: 32px;
}

.c9 ~ * {
  cursor: default;
  margin-top: 5px;
  width: 100%;
}

.c9:hover {
  border-color: #61b0ff;
}

.c9:active {
  border-color: #1c6ee6;
  box-shadow: inset 0 0 0 2px rgba(28,110,230,0.4);
}

.c16 {
  background: #fff;
  border: 1px solid #c5cad3;
  box-sizing: border-box;
  min-height: 50px;
  position: relative;
  width: 100%;
  cursor: text;
  border-color: #1c6ee6;
  box-shadow: inset 0 0 0 2px rgba(28,110,230,0.4);
  height: 32px;
}

.c16 ~ * {
  cursor: default;
  margin-top: 5px;
  width: 100%;
}

.c16:hover {
  border-color: #61b0ff;
}

.c16:active {
  border-color: #1c6ee6;
  box-shadow: inset 0 0 0 2px rgba(28,110,230,0.4);
}

.c16:hover {
  border-color: #1c6ee6;
  box-shadow: inset 0 0 0 2px rgba(28,110,230,0.4);
}

.c20 {
  color: #737482;
  margin: 16px 0 6px 15px;
  margin: 0;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
}

.c11 {
  max-width: 100%;
  padding-top: 6px;
  padding-left: 15px;
  padding-left: 10px;
}

.c13 {
  display: block;
  padding-right: 10px;
  text-align: left;
  width: 100%;
  cursor: inherit;
}

.c13 * {
  cursor: inherit;
}

.c18 {
  font-family: 'Montserrat',sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  overflow: visible;
  background-color: inherit;
  border: transparent;
  display: block;
  line-height: 140%;
  padding-right: 0.625rem;
  padding-left: 0.0625rem;
  width: 100%;
  padding-bottom: 0.375rem;
  font-weight: 800;
  -webkit-letter-spacing: 0.125rem;
  -moz-letter-spacing: 0.125rem;
  -ms-letter-spacing: 0.125rem;
  letter-spacing: 0.125rem;
}

.c18::-moz-focus-inner {
  border: 0;
  padding: 0;
  margin: 0;
}

.c18:active,
.c18:focus {
  outline: none;
}

.c21 {
  margin-right: 0.125rem;
  cursor: pointer;
  width: 1.125rem;
  height: 1.875rem;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 0.125rem;
  border: 1px solid transparent;
}

.c21,
.c21:hover {
  color: #1c6ee6;
}

.c21:focus {
  box-shadow: inset 0 0 0 2px rgba(28,110,230,0.4);
  border: 1px solid #1c6ee6;
  outline: none;
}

.c15 {
  font-family: 'Montserrat',sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  overflow: visible;
  background-color: inherit;
  border: transparent;
  display: block;
  line-height: 140%;
  padding: 0 10px 6px 1px;
  width: 100%;
}

.c15::-moz-focus-inner {
  border: 0;
  padding: 0;
  margin: 0;
}

.c15:active,
.c15:focus {
  outline: none;
}

.c23 {
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  row-gap: 5px;
  -webkit-align-items: start;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: start;
}

.c1 {
  width: 560px;
  background-color: #fff;
  padding: 50px 40px;
}

.c22 {
  font-size: 12px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  color: #737482;
  line-height: 140%;
  margin-bottom: 2px;
}

@media screen and (max-width:390px) {
  .c23 {
    -webkit-flex-direction: column-reverse;
    -ms-flex-direction: column-reverse;
    flex-direction: column-reverse;
  }

  .c23 .btn__element--login-btn {
    margin-bottom: 15px;
  }
}

<div>
  <div
    class="c0 c1"
  >
    <h1
      class="c2"
      style="text-align: center; margin: 0px; padding: 0px;"
    >
      Welcome to 
      Portal Name
    </h1>
    <p
      class="c3"
      font-weight="500"
      style="text-align: center; margin-bottom: 40px;"
    >
      Collaborate with 
      Location Name
       in managing repairs efficiently.
      <br />
      Get started by configuring your profile:
    </p>
    <div
      class="c4"
      style="width: 360px;"
    >
      <div
        class="c5"
      >
        <div
          class="c6 c7"
        >
          <div
            class="c8 c9"
            cursor="text"
          >
            <div
              class="c10 c11"
            >
              <label
                class="c12 c13"
                color="alaskanHusky"
                for="input-field-target-10"
                id="input-field-target-10-label"
              >
                <span>
                  First Name
                  <div
                    aria-controls=""
                    aria-expanded="false"
                    aria-haspopup="dialog"
                    aria-label="Required"
                    class="c14"
                  >
                    <svg
                      color="#009eff"
                      fill="none"
                      focusable="false"
                      height="12"
                      viewBox="0 0 16 16"
                      width="12"
                    >
                      <path
                        d="M8 2.5a1 1 0 011 1v3.613l3.184-1.062a1 1 0 01.633 1.898L9.633 9.01 11.8 11.9a1 1 0 01-1.6 1.2L8 10.167 5.8 13.1a1 1 0 11-1.6-1.2l2.168-2.89-3.184-1.061a1 1 0 01.632-1.898L7 7.113V3.5a1 1 0 011-1z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                </span>
              </label>
              <input
                aria-labelledby="input-field-target-10-label"
                class="c15"
                id="input-field-target-10"
                name="first_name"
                required=""
                value="Jon"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="c5"
      >
        <div
          class="c6 c7"
        >
          <div
            class="c8 c9"
            cursor="text"
          >
            <div
              class="c10 c11"
            >
              <label
                class="c12 c13"
                color="alaskanHusky"
                for="input-field-target-12"
                id="input-field-target-12-label"
              >
                <span>
                  Last Name
                  <div
                    aria-controls=""
                    aria-expanded="false"
                    aria-haspopup="dialog"
                    aria-label="Required"
                    class="c14"
                  >
                    <svg
                      color="#009eff"
                      fill="none"
                      focusable="false"
                      height="12"
                      viewBox="0 0 16 16"
                      width="12"
                    >
                      <path
                        d="M8 2.5a1 1 0 011 1v3.613l3.184-1.062a1 1 0 01.633 1.898L9.633 9.01 11.8 11.9a1 1 0 01-1.6 1.2L8 10.167 5.8 13.1a1 1 0 11-1.6-1.2l2.168-2.89-3.184-1.061a1 1 0 01.632-1.898L7 7.113V3.5a1 1 0 011-1z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                </span>
              </label>
              <input
                aria-labelledby="input-field-target-12-label"
                class="c15"
                id="input-field-target-12"
                name="last_name"
                required=""
                value="Doe"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="c5"
      >
        <div
          class="c6 c7"
        >
          <div
            class="c8 c9"
            cursor="text"
          >
            <div
              class="c10 c11"
            >
              <label
                class="c12 c13"
                color="alaskanHusky"
                for="input-field-target-14"
                id="input-field-target-14-label"
              >
                <span>
                  Email
                  <div
                    aria-controls=""
                    aria-expanded="false"
                    aria-haspopup="dialog"
                    aria-label="Required"
                    class="c14"
                  >
                    <svg
                      color="#009eff"
                      fill="none"
                      focusable="false"
                      height="12"
                      viewBox="0 0 16 16"
                      width="12"
                    >
                      <path
                        d="M8 2.5a1 1 0 011 1v3.613l3.184-1.062a1 1 0 01.633 1.898L9.633 9.01 11.8 11.9a1 1 0 01-1.6 1.2L8 10.167 5.8 13.1a1 1 0 11-1.6-1.2l2.168-2.89-3.184-1.061a1 1 0 01.632-1.898L7 7.113V3.5a1 1 0 011-1z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                </span>
              </label>
              <input
                aria-labelledby="input-field-target-14-label"
                class="c15"
                id="input-field-target-14"
                name="email"
                required=""
                value="email@email.com"
              />
            </div>
          </div>
          
        </div>
      </div>
      <div
        class="c6 c7"
      >
        <div
          class="c8 c16"
          cursor="text"
        >
          <div
            class="c10 c11"
          >
            <label
              class="c12 c13"
              color="alaskanHusky"
              for="input-field-target-16"
              id="input-field-target-16-label"
            >
              <span>
                Password
                <div
                  aria-controls=""
                  aria-expanded="false"
                  aria-haspopup="dialog"
                  aria-label="Required"
                  class="c14"
                >
                  <svg
                    color="#009eff"
                    fill="none"
                    focusable="false"
                    height="12"
                    viewBox="0 0 16 16"
                    width="12"
                  >
                    <path
                      d="M8 2.5a1 1 0 011 1v3.613l3.184-1.062a1 1 0 01.633 1.898L9.633 9.01 11.8 11.9a1 1 0 01-1.6 1.2L8 10.167 5.8 13.1a1 1 0 11-1.6-1.2l2.168-2.89-3.184-1.061a1 1 0 01.632-1.898L7 7.113V3.5a1 1 0 011-1z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              </span>
            </label>
            <div
              class="c17"
            >
              <input
                aria-labelledby="input-field-target-16-label"
                autocomplete="off"
                class="c18"
                data-testid="password-input"
                id="input-field-target-16"
                name="password"
                required=""
                role="password"
                type="password"
                value="abc123@A"
              />
            </div>
          </div>
          <div
            class="c19 c20"
          >
            <div
              aria-controls=""
              aria-expanded="false"
              aria-haspopup="dialog"
              class="c8 c21"
              tabindex="0"
            >
              <svg
                aria-expanded="false"
                color="currentColor"
                data-testid="toggle-password-visible"
                focusable="false"
                height="16"
                role="button"
                viewBox="0 0 16 16"
                width="16"
              >
                <path
                  d="M8 4C5.7 4 3.399 5.658 2.122 8 3.399 10.342 5.7 12 8 12c2.3 0 4.601-1.658 5.878-4C12.601 5.658 10.3 4 8 4zm0-2c3.288 0 6.378 2.36 7.903 5.57a1 1 0 010 .86C14.378 11.64 11.288 14 8 14 4.712 14 1.622 11.64.097 8.43a1 1 0 010-.86C1.622 4.36 4.712 2 8 2zm1 6a1 1 0 112 0 3 3 0 11-3-3 1 1 0 110 2 1 1 0 101 1z"
                  fill="currentColor"
                  fill-rule="nonzero"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div
        style="margin: 5px 0px 20px;"
      >
        <div
          class="c22"
        >
          <svg
            color="#47B052"
            fill="none"
            focusable="false"
            height="12"
            style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
            viewBox="0 0 16 16"
            width="12"
          >
            <path
              clip-rule="evenodd"
              d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-5.707-2.707L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 00-1.414-1.414z"
              fill="currentColor"
              fill-rule="evenodd"
            />
          </svg>
          Contain at least 8 characters
        </div>
        <div
          class="c22"
        >
          <svg
            color="#47B052"
            fill="none"
            focusable="false"
            height="12"
            style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
            viewBox="0 0 16 16"
            width="12"
          >
            <path
              clip-rule="evenodd"
              d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-5.707-2.707L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 00-1.414-1.414z"
              fill="currentColor"
              fill-rule="evenodd"
            />
          </svg>
          Contain at least three of the following: uppercase letters, lowercase letters, digits, and special characters
        </div>
        <div
          class="c22"
        >
          <svg
            color="#47B052"
            fill="none"
            focusable="false"
            height="12"
            style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
            viewBox="0 0 16 16"
            width="12"
          >
            <path
              clip-rule="evenodd"
              d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-5.707-2.707L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 00-1.414-1.414z"
              fill="currentColor"
              fill-rule="evenodd"
            />
          </svg>
          Not contain more than two identical characters in a row
        </div>
      </div>
      <div
        class="c8 c23"
      >
        <div
          class="btn__element--login-btn"
        >
          <button
            class="c24 c25"
            type="button"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
`;

exports[`Form when email is invalid renders the component 1`] = `
.c2 {
  font-weight: 500;
  padding: 0;
  margin: 0;
  font-size: 2.125rem;
  line-height: 120%;
}

.c3 {
  font-weight: 500;
  padding: 0;
  margin: 0;
  color: #737482;
  font-size: 0.875rem;
  line-height: 140%;
}

.c12 {
  font-weight: 500;
  padding: 0;
  margin: 0;
  color: #737482;
  font-size: 0.875rem;
  line-height: 140%;
  font-size: 0.75rem;
}

.c0 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.c4 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.c5 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 10px;
}

.c6 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.c8 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.c10 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.c20 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}

.c22 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: flex-start;
  -webkit-box-align: flex-start;
  -ms-flex-align: flex-start;
  align-items: flex-start;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.c27 {
  font-family: 'Montserrat',sans-serif;
  margin: 0;
  overflow: visible;
  -webkit-appearance: button;
}

.c27::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

.c28 {
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 0.125rem;
  border: 1px solid transparent;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  font-weight: 500;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  line-height: 1;
  outline: none;
  text-transform: uppercase;
  white-space: nowrap;
  font-size: 0.875rem;
  height: 2rem;
  padding: 0 0.625rem;
}

.c28:disabled:disabled {
  background-color: rgba(37,38,46,0.15);
  border-color: transparent;
  color: rgba(37,38,46,0.4);
  cursor: not-allowed;
}

.c19 {
  line-height: 0;
  margin-right: 0.3125rem;
  border-radius: 50%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #ffa300;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}

.c17 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: flex-start;
  -webkit-box-align: flex-start;
  -ms-flex-align: flex-start;
  align-items: flex-start;
  line-height: 1.4;
  text-align: left;
}

.c17 .c18 {
  background-color: transparent;
}

.c14 {
  display: inline;
  margin-left: 3px;
  margin-top: 0px;
}

.c7 {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  max-width: 100%;
}

.c9 {
  background: #fff;
  border: 1px solid #c5cad3;
  box-sizing: border-box;
  min-height: 50px;
  position: relative;
  width: 100%;
  cursor: text;
  height: 32px;
}

.c9 ~ * {
  cursor: default;
  margin-top: 5px;
  width: 100%;
}

.c9:hover {
  border-color: #61b0ff;
}

.c9:active {
  border-color: #1c6ee6;
  box-shadow: inset 0 0 0 2px rgba(28,110,230,0.4);
}

.c16 {
  background: #fff;
  border: 1px solid #c5cad3;
  box-sizing: border-box;
  min-height: 50px;
  position: relative;
  width: 100%;
  cursor: text;
  border-color: #ffa300;
  height: 32px;
}

.c16 ~ * {
  cursor: default;
  margin-top: 5px;
  width: 100%;
}

.c16:hover {
  border-color: #61b0ff;
}

.c16:active {
  border-color: #1c6ee6;
  box-shadow: inset 0 0 0 2px rgba(28,110,230,0.4);
}

.c16:active,
.c16:hover {
  border-color: #ffa300;
}

.c23 {
  color: #737482;
  margin: 16px 0 6px 15px;
  margin: 0;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
}

.c11 {
  max-width: 100%;
  padding-top: 6px;
  padding-left: 15px;
  padding-left: 10px;
}

.c13 {
  display: block;
  padding-right: 10px;
  text-align: left;
  width: 100%;
  cursor: inherit;
}

.c13 * {
  cursor: inherit;
}

.c21 {
  font-family: 'Montserrat',sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  overflow: visible;
  background-color: inherit;
  border: transparent;
  display: block;
  line-height: 140%;
  padding-right: 0.625rem;
  padding-left: 0.0625rem;
  width: 100%;
  padding-bottom: 0.375rem;
  font-weight: 800;
  -webkit-letter-spacing: 0.125rem;
  -moz-letter-spacing: 0.125rem;
  -ms-letter-spacing: 0.125rem;
  letter-spacing: 0.125rem;
}

.c21::-moz-focus-inner {
  border: 0;
  padding: 0;
  margin: 0;
}

.c21:active,
.c21:focus {
  outline: none;
}

.c24 {
  margin-right: 0.125rem;
  cursor: pointer;
  width: 1.125rem;
  height: 1.875rem;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 0.125rem;
  border: 1px solid transparent;
}

.c24,
.c24:hover {
  color: #1c6ee6;
}

.c24:focus {
  box-shadow: inset 0 0 0 2px rgba(28,110,230,0.4);
  border: 1px solid #1c6ee6;
  outline: none;
}

.c15 {
  font-family: 'Montserrat',sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  overflow: visible;
  background-color: inherit;
  border: transparent;
  display: block;
  line-height: 140%;
  padding: 0 10px 6px 1px;
  width: 100%;
}

.c15::-moz-focus-inner {
  border: 0;
  padding: 0;
  margin: 0;
}

.c15:active,
.c15:focus {
  outline: none;
}

.c26 {
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  row-gap: 5px;
  -webkit-align-items: start;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: start;
}

.c1 {
  width: 560px;
  background-color: #fff;
  padding: 50px 40px;
}

.c25 {
  font-size: 12px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  color: #737482;
  line-height: 140%;
  margin-bottom: 2px;
}

@media screen and (max-width:390px) {
  .c26 {
    -webkit-flex-direction: column-reverse;
    -ms-flex-direction: column-reverse;
    flex-direction: column-reverse;
  }

  .c26 .btn__element--login-btn {
    margin-bottom: 15px;
  }
}

<div>
  <div
    class="c0 c1"
  >
    <h1
      class="c2"
      style="text-align: center; margin: 0px; padding: 0px;"
    >
      Welcome to 
      Portal Name
    </h1>
    <p
      class="c3"
      font-weight="500"
      style="text-align: center; margin-bottom: 40px;"
    >
      Collaborate with 
      Location Name
       in managing repairs efficiently.
      <br />
      Get started by configuring your profile:
    </p>
    <div
      class="c4"
      style="width: 360px;"
    >
      <div
        class="c5"
      >
        <div
          class="c6 c7"
        >
          <div
            class="c8 c9"
            cursor="text"
          >
            <div
              class="c10 c11"
            >
              <label
                class="c12 c13"
                color="alaskanHusky"
                for="input-field-target-55"
                id="input-field-target-55-label"
              >
                <span>
                  First Name
                  <div
                    aria-controls=""
                    aria-expanded="false"
                    aria-haspopup="dialog"
                    aria-label="Required"
                    class="c14"
                  >
                    <svg
                      color="#009eff"
                      fill="none"
                      focusable="false"
                      height="12"
                      viewBox="0 0 16 16"
                      width="12"
                    >
                      <path
                        d="M8 2.5a1 1 0 011 1v3.613l3.184-1.062a1 1 0 01.633 1.898L9.633 9.01 11.8 11.9a1 1 0 01-1.6 1.2L8 10.167 5.8 13.1a1 1 0 11-1.6-1.2l2.168-2.89-3.184-1.061a1 1 0 01.632-1.898L7 7.113V3.5a1 1 0 011-1z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                </span>
              </label>
              <input
                aria-labelledby="input-field-target-55-label"
                class="c15"
                id="input-field-target-55"
                name="first_name"
                required=""
                value=""
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="c5"
      >
        <div
          class="c6 c7"
        >
          <div
            class="c8 c9"
            cursor="text"
          >
            <div
              class="c10 c11"
            >
              <label
                class="c12 c13"
                color="alaskanHusky"
                for="input-field-target-57"
                id="input-field-target-57-label"
              >
                <span>
                  Last Name
                  <div
                    aria-controls=""
                    aria-expanded="false"
                    aria-haspopup="dialog"
                    aria-label="Required"
                    class="c14"
                  >
                    <svg
                      color="#009eff"
                      fill="none"
                      focusable="false"
                      height="12"
                      viewBox="0 0 16 16"
                      width="12"
                    >
                      <path
                        d="M8 2.5a1 1 0 011 1v3.613l3.184-1.062a1 1 0 01.633 1.898L9.633 9.01 11.8 11.9a1 1 0 01-1.6 1.2L8 10.167 5.8 13.1a1 1 0 11-1.6-1.2l2.168-2.89-3.184-1.061a1 1 0 01.632-1.898L7 7.113V3.5a1 1 0 011-1z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                </span>
              </label>
              <input
                aria-labelledby="input-field-target-57-label"
                class="c15"
                id="input-field-target-57"
                name="last_name"
                required=""
                value=""
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="c5"
      >
        <div
          class="c6 c7"
        >
          <div
            class="c8 c16"
            cursor="text"
          >
            <div
              class="c10 c11"
            >
              <label
                class="c12 c13"
                color="alaskanHusky"
                for="input-field-target-59"
                id="input-field-target-59-label"
              >
                <span>
                  Email
                  <div
                    aria-controls=""
                    aria-expanded="false"
                    aria-haspopup="dialog"
                    aria-label="Required"
                    class="c14"
                  >
                    <svg
                      color="#009eff"
                      fill="none"
                      focusable="false"
                      height="12"
                      viewBox="0 0 16 16"
                      width="12"
                    >
                      <path
                        d="M8 2.5a1 1 0 011 1v3.613l3.184-1.062a1 1 0 01.633 1.898L9.633 9.01 11.8 11.9a1 1 0 01-1.6 1.2L8 10.167 5.8 13.1a1 1 0 11-1.6-1.2l2.168-2.89-3.184-1.061a1 1 0 01.632-1.898L7 7.113V3.5a1 1 0 011-1z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                </span>
              </label>
              <input
                aria-labelledby="input-field-target-59-label"
                class="c15"
                id="input-field-target-59"
                name="email"
                required=""
                value="email@email.com"
              />
            </div>
          </div>
          <div
            class="c17"
          >
            <div
              aria-hidden="true"
              class="c18 c19"
              color="#ffa300"
            >
              <svg
                color="#ffa300"
                fill="none"
                focusable="false"
                height="16"
                viewBox="0 0 16 16"
                width="16"
              >
                <path
                  clip-rule="evenodd"
                  d="M8 16A8 8 0 108 0a8 8 0 000 16zM7 5a1 1 0 012 0v3a1 1 0 11-2 0V5zm2 6a1 1 0 11-2 0 1 1 0 012 0z"
                  fill="currentColor"
                  fill-rule="evenodd"
                />
              </svg>
            </div>
            <div>
              <p
                class="c12"
                color="alaskanHusky"
              >
                Invalid email.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="c6 c7"
      >
        <div
          class="c8 c9"
          cursor="text"
        >
          <div
            class="c10 c11"
          >
            <label
              class="c12 c13"
              color="alaskanHusky"
              for="input-field-target-61"
              id="input-field-target-61-label"
            >
              <span>
                Password
                <div
                  aria-controls=""
                  aria-expanded="false"
                  aria-haspopup="dialog"
                  aria-label="Required"
                  class="c14"
                >
                  <svg
                    color="#009eff"
                    fill="none"
                    focusable="false"
                    height="12"
                    viewBox="0 0 16 16"
                    width="12"
                  >
                    <path
                      d="M8 2.5a1 1 0 011 1v3.613l3.184-1.062a1 1 0 01.633 1.898L9.633 9.01 11.8 11.9a1 1 0 01-1.6 1.2L8 10.167 5.8 13.1a1 1 0 11-1.6-1.2l2.168-2.89-3.184-1.061a1 1 0 01.632-1.898L7 7.113V3.5a1 1 0 011-1z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              </span>
            </label>
            <div
              class="c20"
            >
              <input
                aria-labelledby="input-field-target-61-label"
                autocomplete="off"
                class="c21"
                data-testid="password-input"
                id="input-field-target-61"
                name="password"
                required=""
                role="password"
                type="password"
                value=""
              />
            </div>
          </div>
          <div
            class="c22 c23"
          >
            <div
              aria-controls=""
              aria-expanded="false"
              aria-haspopup="dialog"
              class="c8 c24"
              tabindex="0"
            >
              <svg
                aria-expanded="false"
                color="currentColor"
                data-testid="toggle-password-visible"
                focusable="false"
                height="16"
                role="button"
                viewBox="0 0 16 16"
                width="16"
              >
                <path
                  d="M8 4C5.7 4 3.399 5.658 2.122 8 3.399 10.342 5.7 12 8 12c2.3 0 4.601-1.658 5.878-4C12.601 5.658 10.3 4 8 4zm0-2c3.288 0 6.378 2.36 7.903 5.57a1 1 0 010 .86C14.378 11.64 11.288 14 8 14 4.712 14 1.622 11.64.097 8.43a1 1 0 010-.86C1.622 4.36 4.712 2 8 2zm1 6a1 1 0 112 0 3 3 0 11-3-3 1 1 0 110 2 1 1 0 101 1z"
                  fill="currentColor"
                  fill-rule="nonzero"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div
        style="margin: 5px 0px 20px;"
      >
        <div
          class="c25"
        >
          <svg
            color="#C5CAD3"
            fill="none"
            focusable="false"
            height="12"
            style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
            viewBox="0 0 16 16"
            width="12"
          >
            <path
              d="M10.7 6.7L9.4 8l1.3 1.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3L8 9.4l-1.3 1.3c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L6.6 8 5.3 6.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L8 6.6l1.3-1.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4z"
              fill="currentColor"
            />
            <path
              clip-rule="evenodd"
              d="M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM8 2C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z"
              fill="currentColor"
              fill-rule="evenodd"
            />
          </svg>
          Contain at least 8 characters
        </div>
        <div
          class="c25"
        >
          <svg
            color="#C5CAD3"
            fill="none"
            focusable="false"
            height="12"
            style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
            viewBox="0 0 16 16"
            width="12"
          >
            <path
              d="M10.7 6.7L9.4 8l1.3 1.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3L8 9.4l-1.3 1.3c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L6.6 8 5.3 6.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L8 6.6l1.3-1.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4z"
              fill="currentColor"
            />
            <path
              clip-rule="evenodd"
              d="M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM8 2C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z"
              fill="currentColor"
              fill-rule="evenodd"
            />
          </svg>
          Contain at least three of the following: uppercase letters, lowercase letters, digits, and special characters
        </div>
        <div
          class="c25"
        >
          <svg
            color="#C5CAD3"
            fill="none"
            focusable="false"
            height="12"
            style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
            viewBox="0 0 16 16"
            width="12"
          >
            <path
              d="M10.7 6.7L9.4 8l1.3 1.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3L8 9.4l-1.3 1.3c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L6.6 8 5.3 6.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L8 6.6l1.3-1.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4z"
              fill="currentColor"
            />
            <path
              clip-rule="evenodd"
              d="M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM8 2C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z"
              fill="currentColor"
              fill-rule="evenodd"
            />
          </svg>
          Not contain more than two identical characters in a row
        </div>
      </div>
      <div
        class="c8 c26"
      >
        <div
          class="btn__element--login-btn"
        >
          <button
            class="c27 c28"
            disabled=""
            type="button"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
`;
